export const splitScreenGridButtonClicked = (text, target) => ({
  type: 'Split Screen Grid Component Button Clicked',
  data: {
    text,
    target,
  },
});
